import { Routes } from '@angular/router';
import { authGuard } from '../guard/auth.guard';

export const masterRoutes: Routes = [
    {
        path: 'master/assets',
        loadComponent: () => import('../master/master.component').then((m) => m.MasterComponent),
        canActivate: [authGuard]
    },
    {
        path: 'master/equity-liabilities',
        loadComponent: () =>
            import('../master/equity-and-liabilities/equity-and-liabilities.component').then(
                (m) => m.EquityAndLiabilitiesComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'master/cluster-type',
        loadComponent: () =>
            import('../master/cluster-type/cluster-type.component').then((m) => m.ClusterTypeMasterComponent),
        canActivate: [authGuard]
    }
];
